<!--
  Generated template for the NearbyEventParticipantsPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->


<!--
ATTENTION!
This page is no longer used from build 1.1.94.
The component is merged into NearbyEventParticipantSearch
-->

<ion-header>

  <ion-toolbar>
    <ion-title>{{'NEARBYEVENT_PARTICIPANTS_TITLE' | translate}}</ion-title>
  </ion-toolbar>

</ion-header>


<ion-content>
  <ion-list>
    <!-- ITEM TEMPLATE -->
    <ion-item-sliding animated *ngFor="let participant of activeItem.participants">
      <ion-item class="result-header">
        <ion-avatar item-start>
          <img src="{{participant.img}}">
        </ion-avatar>
        <span inline-block>
          <h2 text-ellipsis text-bold>{{participant.firstName}} {{participant.lastName}}</h2>
        </span>
      </ion-item>
      <ion-item-options side="right">
        <ion-item-option (click)="remove(participant)">
          <ion-icon name="trash" color="danger"></ion-icon>
          {{'RESERVATION_RELEASE' | translate}}
        </ion-item-option>
      </ion-item-options>
    </ion-item-sliding>
    <!-- END ITEM TEMPLATE -->

  </ion-list>
  <div padding-top *ngIf="!activeItem || activeItem.participants.length === 0">
    <p text-small text-center>{{'NEARBYEVENT_PARTICIPANTS_TIP_1' | translate}} <br />
      {{'NEARBYEVENT_PARTICIPANTS_TIP_2' |
      translate}}</p>
  </div>
  <ion-fab right bottom>
    <button ion-fab color="primary" (click)="showSearch()">
      <ion-icon name="add"></ion-icon>
    </button>
  </ion-fab>
</ion-content>